import { makeStyles } from '@material-ui/core/styles';
import GridAreaContainer from '@sprinx/react-mui-components/GridAreaContainer';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { CatalogueProduct } from '../../../api/products/catalogue';
import ProductStockQuantityInfo from '../../../components/ProductStockQuantityInfo';

export interface CataloguePageListContentItemRowStockInfoProps
  extends StandardDivProps<CataloguePageListContentItemRowStockInfoClassKey> {
  product: CatalogueProduct;
}

export type CataloguePageListContentItemRowStockInfoClassKey = 'root';

const themeSettings = { name: 'CataloguePageListContentItemRowStockInfo' };
const useStyles = makeStyles(
  (/* theme */) => ({
    root: {},
  }),
  themeSettings,
);

const CataloguePageListContentItemRowStockInfo = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemRowStockInfoProps
>(({ className, classes: pClasses, product }, ref) => {
  const classes = useStyles({ classes: pClasses });

  return (
    <GridAreaContainer ref={ref} className={clsx(classes.root, className)} renderToGridArea='stockInfo'>
      <ProductStockQuantityInfo product={product} />
    </GridAreaContainer>
  );
});

CataloguePageListContentItemRowStockInfo.displayName = 'CataloguePageListContentItemRowStockInfo';

export default withThemeProps(themeSettings)(CataloguePageListContentItemRowStockInfo);
